<!-- Circle Selection Panel -->
<div class="circle-selection-panel">
    
    <hr class="menu-line-separator" />
    
    <!-- Circle Button with Expandable Configuration -->
    <div mat-menu-item class="selection-item" (click)="toggleCircleConfig(); $event.stopPropagation()">
        <span class="selection-icon">
            <mat-icon fontIcon="fa-circle" fontSet="far"></mat-icon>
        </span>
        <span class="selection-label">Circle</span>
    </div>
    
    <!-- Circle Configuration Panel (Expandable) -->
    <div class="circle-config" *ngIf="isCircleExpanded" (click)="$event.stopPropagation()">
        
        <!-- Unit Label and Dropdown -->
        <div class="config-label">Unit</div>
        <mat-form-field appearance="fill" class="config-field">
            <mat-select [(value)]="radiusUnit" (selectionChange)="onUnitChange($event.value)">
                <mat-option *ngFor="let unit of radiusUnits" [value]="unit.value">
                    {{ unit.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        
        <!-- Radius Label and Input -->
        <div class="config-label">Radius</div>
        <mat-form-field appearance="fill" class="config-field">
            <input 
                matInput 
                type="number" 
                [(ngModel)]="radiusValue"
                (ngModelChange)="onRadiusChange($event)"
                min="0"
                step="1"
            />
        </mat-form-field>
        
        <!-- Create Circle Button -->
        <button 
            mat-raised-button 
            class="create-circle-btn"
            [disabled]="!isValidRadius()"
            (click)="onCreateCircle()">
            Create Circle
        </button>
    </div>
    
    <hr class="menu-line-separator" />


    <!-- Polygon Button (Enabled) -->
    <div mat-menu-item class="selection-item" (click)="onPolygonClick()">
        <span class="selection-icon">
            <mat-icon style="width: 15px" fontIcon="fa-hexagon" fontSet="far"></mat-icon>
        </span>
        <span class="selection-label">Polygon</span>
    </div>
    
    <hr class="menu-line-separator" />

    <!-- Polygon New Button: click-to-add-vertex, captured without DrawingManager -->
    <div mat-menu-item class="selection-item" (click)="onPolygonNewClick()">
        <span class="selection-icon">
            <mat-icon style="width: 15px" fontIcon="fa-draw-polygon" fontSet="fas"></mat-icon>
        </span>
        <span class="selection-label">Polygon New</span>
    </div>

    <hr class="menu-line-separator" />

    <!-- Rectangle Button (Enabled) -->
    <div mat-menu-item class="selection-item" (click)="onRectangleClick()">
        <span class="selection-icon">
            <mat-icon fontIcon="fa-square" fontSet="far"></mat-icon>
        </span>
        <span class="selection-label">Rectangle</span>
    </div>

    <hr class="menu-line-separator" />

    <!-- Rectangle New Button: drag-to-draw, captured without DrawingManager -->
    <div mat-menu-item class="selection-item" (click)="onRectangleNewClick()">
        <span class="selection-icon">
            <mat-icon fontIcon="fa-vector-square" fontSet="fas"></mat-icon>
        </span>
        <span class="selection-label">Rectangle New</span>
    </div>

    <hr class="menu-line-separator" />
    
    <!-- Cancel Button (also clears all circles) -->
    <div mat-menu-item class="selection-item" (click)="onCancelClick()">
        <span class="selection-icon">
            <mat-icon fontIcon="fa-times-circle" fontSet="far"></mat-icon>
        </span>
        <span class="selection-label">Cancel</span>
    </div>
    
</div>
